export default __webpack_public_path__ + "static/media/mobile.4a703b2e.png";